import React from "react";
import { Card, CardBody } from "mdbreact";
// ta4pafa3fataya
// const api = "https://127.0.0.1/";
const api = "https://api.lushplans.com/";
const url = `${api}_vendors/?token=APyOXy3w60i2MpJ7F8PMAy-neZY3pjnOnaZUGB5BEomqc73vOCdmp6NtASyVR-KU3nYojdBZYzC6ghjz6On8Wm6rq34M7A-iNPGBtpiXIBL-MgGNoULDCFYiGfUPxZ1dwQYPqjeSH45nDOhRdjhcQaxcMiVSkk1QPTOJLiYkgYW-ISVGdtfL9s5efJlSEmAySy6FpPeINZAx9TMATKkgDRv77oZoYviGihxmCWdLYKhpsVT_xTY5w2RGv02LNwwH0Bp3ZnHc_sApC1_BQKsVjAHy5eYAHijQmFcXpL1fLSjVqH_mWkMD6FUuz4dJUnomR2VRWpNVcZQ83zigmaWgfz1Jjtnzz6DDkvLkC2JONeOq12J2yl6XRlvVNcq7nC8gRCRP3SOMSFhg{!EXTERNALAUTH!}&_id=google.com***ID***101394503087099242953&stat=`;
const signUpURL = "https://vendor.lushplans.com/";
const vendorMapping = {
  ta4pa: "Top Vendor", // ta4pa
  ta4patahara22: "Top 3", // ta4patahara22
  ta4pafa3va2: "Top 5", // ta4pafa3va2
  ta4pata2na: "Top 10", // ta4pata2na
  ta4patawa2nataya: "Top 20" // ta4patawa2nataya
  // 'ta4pafa2fataya': 'Top 50', // ta4pafa2fataya
  // 'ta4paha5nadara2da': 'Top 100', // ta4paha5nadara2da
  // '1lala': 'Default' // 1lala
};

const mappingKeys = Object.keys(vendorMapping);

const FilterItem = props => {
  return <option value={props.type}>{props.type}</option>;
};

const VendorCard = props => {
  var { profile } = props;
  if (props.types[0] === null) {
    console.log(props);
  }
  return (
    <div className="col-md-4 col-xs-12 col-sm-6 col-lg-3 col-center-block">
      <Card>
        <img className="card-img" src={props.image} alt={profile.name} />
        <CardBody>
          <h5 className="pink-text">
            <i className="fa fa-trophy" />
            {props.types[0] ? props.types[0].toUpperCase() : ""}
            <span className="pull-right">
              {props.rank ? ordinaled(props.rank) : ""}
            </span>
          </h5>
          <div className="card-body">
            <h4 className="card-title text-center vendorName">
              <strong>
                {profile && profile.name
                  ? profile.name
                  : props.id.replace("@", "")}
              </strong>
            </h4>
            <h6>
              {" "}
              <i className="fa fa-heart rating" />
              {"  " +
                props.likes.toLocaleString(navigator.language, {
                  minimumFractionDigits: 0
                })}{" "}
              lush feels
            </h6>
            <h6>
              {" "}
              <i className="fa fa-edit rating" />
              {"  " +
                props.appearance.toLocaleString(navigator.language, {
                  minimumFractionDigits: 0
                })}{" "}
              lush weddings
            </h6>
            <h6>
              {" "}
              <i className="fa fa-comments rating" />
              {"  " +
                props.comments.toLocaleString(navigator.language, {
                  minimumFractionDigits: 0
                })}{" "}
              lush taps
            </h6>
            <hr />
            <p className="card-text text-center soc-med-buttons">
              {isSocialMedia(
                "https://facebook.com/",
                profile.facebook,
                "fa fa-facebook"
              )}
              {isSocialMedia(
                "https://instagram.com/",
                props.id,
                "fa fa-instagram"
              )}
              {isSocialMedia(
                "https://twitter.com/",
                profile.twitter,
                "fa fa-twitter"
              )}
              {profile.address ? isValidLocation(profile.address.trim()) : null}
            </p>
            <hr />
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <button
              className="btn-save btn btn-primary btn-sm"
              id="claimBtn"
              hidden={props.profile.city}
            >
              <a
                href={`${signUpURL}?ig=${props.id.replace(
                  "@",
                  ""
                )}&country=Nigeria&state=Lagos
              &city=Lagos&name=${props.id.replace("@", "")}&type=${
                  props.types ? props.types[0] : ""
                }`}
                target="_blank"
                rel="noreferrer noopener"
              >
                Update profile
              </a>
            </button>
            <button
              className="btn-save btn btn-primary btn-sm pull-right"
              onClick={props.this.onCardClick.bind(props.this, props)}
            >
              View
            </button>
          </div>
        </CardBody>
      </Card>
      <hr />
    </div>
  );
};

function ordinaled(i) {
  var j = i % 10,
    k = i % 100;
  if (j === 1 && k !== 11) {
    return i + "st";
  }
  if (j === 2 && k !== 12) {
    return i + "nd";
  }
  if (j === 3 && k !== 13) {
    return i + "rd";
  }
  return i + "th";
}

const isValidLocation = address => {
  if (!address) {
    return null;
  }
  var encodedAddress = encodeURIComponent(address);
  var map_url = `https://google.com/maps/search/?api=1&query=${encodedAddress}`;
  return (
    <a
      type="button"
      className="btn-floating btn-sm text-center"
      href={map_url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fa fa-map" />
    </a>
  );
};

const isSocialMedia = (socialMediaBaseURL, mediaURL, iconClasses) => {
  if (!mediaURL) {
    return null;
  }
  mediaURL.replace("@", "");

  return (
    <a
      type="button"
      className="btn-floating btn-sm text-center"
      href={`${socialMediaBaseURL}${mediaURL.replace("@", "")}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className={iconClasses} />
    </a>
  );
};

export {
  url,
  vendorMapping,
  mappingKeys,
  FilterItem,
  VendorCard,
  api,
  ordinaled
};



// WEBPACK FOOTER //
// ./src/List/List.consts.js